import Global from '../../../store/global-selectors';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';
import { NotificationService } from 'ui-components/services/notification-service';

import { printLabelRequest } from '../../../store/batches/print/batches.print.actions';
import { printLabel } from '../../../store/printing/print.actions';
import { hasGridOrderingEnabledForBulkPrint } from '../../../services/bulk-label-ordering-service';
import { getQuickshipPropsFromState } from '../../../store/quickship/quickship.helpers';
import { FillMethods } from '../../../enums/fill-methods';

export const FirePrintLabelStep = (state, jobId) => {
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  if (!jobData || !jobData.notificationId) {
    return [JobPipelineActions.exitJobPipeline(jobId)];
  }
  const { fulfillmentPlanIds, fulfillmentIds, notificationId, batchId } = jobData;
  const fillMethod = Global.selectBatchesLabelBatchStatusModalFillMethodByBatchId(state, {
    batchId: batchId?.toString(),
  });
  const sellerSettings = Global.selectSellerData(state).settings || {};
  const hasGridOrderingEnabled = hasGridOrderingEnabledForBulkPrint(sellerSettings);
  NotificationService.removeNotification(notificationId);

  const { shouldUseQuickship } = getQuickshipPropsFromState(state);
  const quickshipShouldShowPrintDialog = Global.selectUserQuickshipShouldShowPrintDialog(state);
  const autoPrint = shouldUseQuickship && !quickshipShouldShowPrintDialog;
  const shouldNotLaunchPrintModal = !quickshipShouldShowPrintDialog;

  // this should be the first time we print these documents, the Print Labels button does it's own check and handles with a prompt
  const alreadyPrintedCount = 0;

  if (fillMethod === FillMethods.fulfillment) {
    return JobPipelineActions.goForwardOnJob(jobId);
  }

  // TODO: remove this block when the printLabelRequest end-point (or createLabel2) support the order selection as the label ordering
  // batch === undefined check added in QuickShip implementation
  if (hasGridOrderingEnabled || batchId === undefined) {
    return [
      printLabel(fulfillmentPlanIds, fulfillmentIds, undefined, true, autoPrint, shouldNotLaunchPrintModal),
      JobPipelineActions.goForwardOnJob(jobId),
    ];
  }

  return [
    printLabelRequest([batchId], autoPrint, fulfillmentPlanIds.length, alreadyPrintedCount, undefined, shouldNotLaunchPrintModal),
    JobPipelineActions.goForwardOnJob(jobId),
  ];
};
